












import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

@Component({
    name: 'TranslationsButton',
    components: {},
})
export default class TranslationsButton extends Vue {
    private mainStore = mainStore.context(this.$store);

    private changeLanguajeToSpanish(): void {
        this.mainStore.actions.changeLanguajeToSpanish();
    }

    private changeLanguajeToEnglish(): void {
        this.mainStore.actions.changeLanguajeToEnglish();
    }

    private get currentLanguage(): string | null {
        return this.mainStore.state.currentLanguage;
    }

    private changeLanguage(): void {
        if (this.currentLanguage === 'es') {
            this.changeLanguajeToEnglish();
        } else {
            this.changeLanguajeToSpanish();
        }
    }
}
